import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Layers, ShieldCheck } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide06Timeline({
  index
}: SlideProps) {
  return <InteriorSlide surface data-id="element-125">
      <SlideHeader eyebrow="Then: Become Your Africa Campaign Agency" data-id="element-126">
        Annual Partnership
      </SlideHeader>

      <div className="flex-1 flex flex-col items-center justify-center max-w-5xl mx-auto w-full text-center" data-id="element-127">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="text-4xl md:text-6xl font-extrabold text-[var(--fg)] tracking-tight mb-16" data-id="element-128">
          One partnership.
          <br data-id="element-129" />
          <span className="text-[var(--brand)]" data-id="element-130">Four brands.</span>
          <br data-id="element-131" />
          The whole continent.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full" data-id="element-132">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="flex flex-col items-center" data-id="element-133">
            <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center text-[var(--brand)] shadow-sm mb-4" data-id="element-134">
              <ShieldCheck className="h-8 w-8" data-id="element-135" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)] mb-2" data-id="element-136">
              Partnering to Deliver
            </h3>
            <p className="text-[var(--muted)]" data-id="element-137">
              Simplified procurement and predictable annual costs.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="flex flex-col items-center" data-id="element-138">
            <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center text-[var(--brand)] shadow-sm mb-4" data-id="element-139">
              <Layers className="h-8 w-8" data-id="element-140" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)] mb-2" data-id="element-141">
              Four Brands
            </h3>
            <p className="text-[var(--muted)]" data-id="element-142">
              Breast Cancer, MS, Ophthalmology, and Hemophilia.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.7,
          duration: 0.5
        }} className="flex flex-col items-center" data-id="element-143">
            <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center text-[var(--brand)] shadow-sm mb-4" data-id="element-144">
              <Globe className="h-8 w-8" data-id="element-145" />
            </div>
            <h3 className="text-xl font-bold text-[var(--fg)] mb-2" data-id="element-146">
              Whole Continent
            </h3>
            <p className="text-[var(--muted)]" data-id="element-147">
              Scalable across Ivory Coast, West Africa, and beyond.
            </p>
          </motion.div>
        </div>
      </div>
    </InteriorSlide>;
}